/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { avatarsGet } from "../../funcs/avatarsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAvatarRequest$inboundSchema,
};

export const tool$avatarsGet: ToolDefinition<typeof args> = {
  name: "avatars-get",
  description: `Get avatar image for an account using a unique ID.    

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/profile-enrichment.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await avatarsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
